import { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { formatWord, replaceUndersocreAndFormat } from "../../Utils/utils";
import useHandleChangeHooks from "../../../../hooks/digitalMarketing/useHandleChangeHooks";
import CustomInputs from "../../../../Component/DigitalMarketing/CustomInputs";
import ModalComponent from "../../Appoinment/component/ModalComponent";
import { useGetConsultantCalendarViewQuery } from "../../../../Service/consultant";
import {
  useGetTimeSlotsQuery,
  useUpdateAppointmentMutation,
  useUpdateRescheduleAppointmentMutation,
} from "../../../../Service/appoinment";
import TimeSlotSelector from "../../Appoinment/NewAppointments/TimeSlotsComponent";
import BackdropLoader from "../../../../Component/DigitalMarketing/BackDropLoader";
import { Tooltip } from "@mui/material";

const AppointmentCalendarView = (props: any) => {
  const { consultantid } = props;
  console.log(consultantid);
  const { data: consultantData, refetch } = useGetConsultantCalendarViewQuery(
    { id: consultantid },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  console.log(consultantData);
  const { formData, setFormData, handleChange, submit, setSubmit } =
    useHandleChangeHooks({});
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const calendarRef = useRef<any>(null);
  const [showCancel, setShowCancel] = useState({
    show: false,
    id: "",
    type: "",
  });
  const [activePopover, setActivePopover] = useState<any>(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [slotId, setSlotId] = useState(null);
  const [selected, setSelected] = useState(null);

  const appointmentTypeOptions = [
    { id: "in-Person", label: "In Person" },
    { id: "virtual", label: "Virtual" },
  ];
  const payment = [
    { id: "ConsultantFee", label: "Consultant Fee" },
    { id: "OtherPayment", label: "Other Payment" },
  ];
  const paymentMode = [
    { id: "Online", label: "Online Payment" },
    { id: "Cash", label: "Cash" },
    { id: "Card", label: "Card" },
  ];

  const [updateStatus, {data:statusData, isLoading: updateLoading, isSuccess: updateSuccess }] =
    useUpdateAppointmentMutation();

  const [
    updateReschedule,
    {
      data: statusRescheduleData,
      isLoading: updateRescheduleLoading,
      isSuccess: updateRescheduleSuccess,
    },
  ] = useUpdateRescheduleAppointmentMutation();

  const { data: timeSlots } = useGetTimeSlotsQuery(
    {
      id: selectedEvent?.consultantId,
      date: formData.appointmentDate,
      type: formData.appointmentType === "in-Person" ? "in-Person" : "virtual",
    },
    {
      refetchOnMountOrArgChange: true,
      skip:
        !formData.appointmentDate &&
        !formData.consultantId &&
        formData.appointmentType === "",
    }
  );
  useEffect(() => {
    const calendarEvents = consultantData?.data.map(
      (appointment: any, index: number) => {
        const startDate = new Date(
          `${appointment.appointmentDate} ${appointment.appointmentTime}`
        ).toISOString();
        const endDate = new Date(
          new Date(startDate).getTime() + 15 * 60 * 1000
        ).toISOString();
        const colorClass =
          index % 5 === 0
            ? "green-event"
            : index % 5 === 1
            ? "orange-event"
            : index % 5 === 2
            ? "blue-event"
            : index % 5 === 3
            ? "purple-event"
            : "yellow-event";

        const colortimeClass =
          index % 5 === 0
            ? "time-green-event"
            : index % 5 === 1
            ? "time-orange-event"
            : index % 5 === 2
            ? "time-blue-event"
            : index % 5 === 3
            ? "time-purple-event"
            : "time-yellow-event";

        return {
          title: appointment.customerName,
          start: startDate,
          end: endDate,
          classNames: [colorClass],
          allDay: false,
          extendedProps: { colortimeClass, details: appointment },
        };
      }
    );

    setEvents(calendarEvents);
  }, [consultantData]);

  const handleTimeSlotChange = (time) => {
    setSelectedTime(time.time);
    setSlotId(time.id)
  };

  const handleCancel = (Id: any, Type: string) => {
    setShowCancel((prev) => ({
      ...prev,
      show: true,
      id: Id,
      type: Type,
    }));
    setActivePopover(null); // Hide the popover
  };

  const handleReschedule = (Id: any, Type: string, event: any) => {
    setFormData([]);
    setShowCancel((prev) => ({
      ...prev,
      show: false,
      id: Id,
      type: Type,
    }));
    setSelectedEvent(event.extendedProps?.details);
  };

  const handleCancelSubmit = () => {
    setSubmit(true);
    if (showCancel.type === "reschedule") {
      const payload = {
        ...formData,
        appointmentTime: selectedTime,
        consultantId: selectedEvent?.consultantId,
        customerId: selectedEvent?.customersId,
        patientSend: selectedEvent.patientSend,
        consultantSend: selectedEvent?.consultantSend,
        slotId:slotId
      };
      updateReschedule({ id: showCancel.id, ...payload });
    } else {
      const payload = {
        ...formData,
        status: showCancel.type === "cancel" ? "cancel" : "completed",
        ...(formData.reason ? { reason: formData.reason } : {}),
        appointmentType: selected?.extendedProps?.details?.appointmentType,
        amount: formData.payment === "ConsultantFee"
          ? selected?.extendedProps?.details?.consultantFee
          : formData?.consultantFee,
      };
      updateStatus({ id: showCancel.id, ...payload });
    }
  };

  const updateDateRange = () => {
    if (calendarRef.current) {
      calendarRef.current.getApi();
    }
  };
  const handlePrev = () => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.prev();
      updateDateRange();
    }
  };

  const handleNext = () => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.next();
      updateDateRange();
    }
  };

  const renderEventContent = (eventInfo: any) => {
    const { event } = eventInfo;
    const { colortimeClass } = event.extendedProps;
    const popover = (
      <Popover
        id="popover-basic"
        style={{ minWidth: "300px", maxHeight: "360px", overflow: "auto" }}
      >
        <div className="fw-16 fw-400 d-flex justify-content-center align-items-center mt-2 p-2">
          {event.extendedProps?.details?.status === "scheduled" && (
            <span
              className="schedule-bg-color d-flex justify-content-center align-items-center rounded"
              style={{ width: "100%" }}
            >
              Scheduled
            </span>
          )}
          {event.extendedProps?.details?.status === "reScheduled" && (
            <span
              className="schedule-bg-color d-flex justify-content-center align-items-center rounded"
              style={{ width: "100%" }}
            >
              Re-Scheduled
            </span>
          )}
          {event.extendedProps?.details?.status === "completed" && (
            <span
              className="bg-success text-white d-flex justify-content-center align-items-center rounded"
              style={{ width: "100%" }}
            >
              Completed
            </span>
          )}
          {event.extendedProps?.details?.status === "canceled" && (
            <span
              className="bg-danger text-white d-flex justify-content-center align-items-center rounded"
              style={{ width: "100%" }}
            >
              Canceled
            </span>
          )}
        </div>
        <Popover.Body>
          <div className="f-24 fw-600">
            {replaceUndersocreAndFormat(event.title)}
          </div>
          <div className="d-flex gap-1">
            {event.extendedProps?.details?.phone1 && (
              <li>{event.extendedProps?.details?.phone1}</li>
            )}
            {event.extendedProps?.details?.sex && (
              <li>{event.extendedProps?.details?.sex}</li>
            )}
          </div>
          {showCancel.type !== "reschedule" && (
            <>
              <div className=" mt-1">
                {event.extendedProps?.details.appointmentType ===
                "in-Person" ? (
                  <div className="d-flex align-items-center gap-1 rounded-pill p-2 in-person">
                    <span className="material-symbols-outlined fw-bold">
                      group
                    </span>
                    <span>
                      {replaceUndersocreAndFormat(
                        event.extendedProps?.details?.appointmentType
                      )}
                    </span>
                  </div>
                ) : (
                  <div className="d-flex align-items-center gap-1 rounded-pill p-2 virtual">
                    <span className="material-symbols-outlined fw-bold">
                      video_call
                    </span>
                    <span>
                      {replaceUndersocreAndFormat(
                        event.extendedProps?.details?.appointmentType
                      )}
                    </span>
                  </div>
                )}
              </div>
              <hr />
              <div>
                <span className="f-20 fw-600 " style={{ color: "#6842D9" }}>
                  Dr.
                  {replaceUndersocreAndFormat(
                    event.extendedProps?.details?.consultantName
                  )}
                </span>
              </div>

              <div>
                <span style={{ color: "#696969" }}>on </span>{" "}
                <span className="fw-bold">
                  {event.extendedProps?.details?.appointmentDate}
                </span>{" "}
                <span style={{ color: "#696969" }}>,at</span>{" "}
                <span className="fw-bold">
                  {event.extendedProps?.details?.appointmentTime}
                </span>{" "}
                <span style={{ color: "#696969" }}>for</span>{" "}
                <span className="fw-bold">15 mins</span>
              </div>
            </>
          )}
          {showCancel.type === "reschedule" && (
            <>
              <hr />
              <CustomInputs
                label="Consultation Type"
                type="select"
                option={appointmentTypeOptions}
                labelKey="label"
                valueKey="id"
                validation="required"
                submit={submit}
                {...formData}
                onChange={handleChange}
                name="appointmentType"
                setFormData={setFormData}
              />
              <CustomInputs
                {...formData}
                onChange={handleChange}
                type="date"
                label="Date"
                validation="required"
                submit={submit}
                name="appointmentDate"
                setFormData={setFormData}
              />
              <div>
                <span className="f-14 fw-500 fw-bold">Time Slot</span>
              </div>
              <TimeSlotSelector
                selectedTime={selectedTime}
                onTimeSlotChange={handleTimeSlotChange}
                timeSlots={timeSlots}
              />

              <CustomInputs
                {...formData}
                onChange={handleChange}
                type="normal"
                label="Reason"
                validation="required"
                submit={submit}
                name="reason"
                setFormData={setFormData}
              />
            </>
          )}
          {event.extendedProps?.details?.reason && (
            <div className="d-flex flex-column gap-1 mt-2">
              <span className="f-20 fw-500 fw-bold">Reason</span>
              <span className="f-16 fw-400" style={{ color: "#696969" }}>
                {event.extendedProps?.details?.reason}
              </span>
            </div>
          )}

          {(event.extendedProps?.details?.status === "scheduled" ||
            event.extendedProps?.details?.status === "reScheduled") &&
            showCancel.type !== "reschedule" && (
              <>
                <hr />
                <div className="d-flex justify-content-between">
                  <span
                    className="cursor-pointer"
                    style={{ color: "#E2005C" }}
                    onClick={() =>
                      handleCancel(
                        event.extendedProps?.details?.appointmentId,
                        "cancel"
                      )
                    }
                  >
                    Cancel
                  </span>
                  <span
                    className="cursor-pointer"
                    style={{ color: "#007AFF" }}
                    onClick={() =>
                      handleReschedule(
                        event.extendedProps?.details?.appointmentId,
                        "reschedule",
                        event
                      )
                    }
                  >
                    Reschedule
                  </span>
                  <span
                    onClick={() =>
                      handleCancel(
                        event.extendedProps?.details?.appointmentId,
                        "completed"
                      )
                    }
                    className="cursor-pointer"
                    style={{ color: "#6842D9" }}
                  >
                    Completed
                  </span>
                </div>
              </>
            )}
          {showCancel.type === "reschedule" && (
            <div className="d-flex justify-content-end gap-2">
              {" "}
              <button
                className="btn border text-secondary"
                onClick={() => setShowCancel({ show: false, id: "", type: "" })}
              >
                Cancel
              </button>
              <button
                className="btn btn-violet"
                onClick={() => handleCancelSubmit()}
              >
                Update
              </button>
            </div>
          )}
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger
        rootClose
        trigger="click"
        placement="top"
        overlay={popover}
        show={activePopover === event.extendedProps.details.appointmentId}
        onToggle={() => {
          setActivePopover(
            activePopover === event.extendedProps.details.appointmentId
              ? null
              : event.extendedProps.details.appointmentId
          );
          setSelected(event);
          setFormData([]);
        }}
      >
        <Tooltip
          placement="top"
          arrow={true}
          style={{ cursor: "pointer" }}
          title={
            <>
              <span>Patient Name - {formatWord(event.title)}</span>
              {event.extendedProps?.details?.status && (
                <span
                  className={`d-flex justify-content-center align-items-center rounded ${
                    event.extendedProps.details.status === "scheduled"
                      ? "schedule-bg-color"
                      : event.extendedProps.details.status === "reScheduled"
                      ? "schedule-bg-color"
                      : event.extendedProps.details.status === "completed"
                      ? "bg-success text-white"
                      : event.extendedProps.details.status === "canceled"
                      ? "bg-danger text-white"
                      : ""
                  }`}
                >
                  {event.extendedProps.details.status.charAt(0).toUpperCase() +
                    event.extendedProps.details.status.slice(1)}
                </span>
              )}
            </>
          }
          followCursor={true}
        >
          <div
            className="d-flex justify-content-around "
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex gap-1">
              <div className={colortimeClass}>
                {event.start.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
              <div className={colortimeClass}>
                {event.end.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
          </div>
        </Tooltip>
      </OverlayTrigger>
    );
  };
  console.log(showCancel, "showCancel");
  useEffect(() => {
    if (updateSuccess && statusData?.authUrl) {
      window.open(statusData?.authUrl, "_blank");
      setShowCancel({ show: false, id: "", type: "" });
    } else {
      setShowCancel({ show: false, id: "", type: "" });
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (updateRescheduleSuccess) {
      setShowCancel({ show: false, id: "", type: "" });
    }
  }, [updateRescheduleSuccess]);
  return (
    <>
      <BackdropLoader loader={updateLoading || updateRescheduleLoading} />
      <FullCalendar
        ref={calendarRef}
        plugins={[timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        headerToolbar={{
          left: "customPrev,customNext",
          center: "title",
          right: "",
        }}
        customButtons={{
          customPrev: {
            text: `‹`,
            click: handlePrev,
          },

          customNext: {
            text: `›`,
            click: handleNext,
          },
        }}
        eventOverlap={false}
        slotEventOverlap={false}
        slotMinTime="00:00:00"
        slotMaxTime="24:00:00"
        slotLabelFormat={{
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }}
        dayHeaderFormat={{
          weekday: "long",
          day: "2-digit",
        }}
        height="75vh"
        allDaySlot={false}
        nowIndicator={true}
        events={events}
        eventContent={renderEventContent}
      />
      <ModalComponent
        title="Update Status"
        show={showCancel.show}
        onSubmit={handleCancelSubmit}
        body={
          <>
             {(showCancel.type === "complete" ||
              showCancel.type === "completed") && (
              <div>
                <CustomInputs
                  {...formData}
                  onChange={handleChange}
                  type="select"
                  label="Payment"
                  validation="required"
                  labelKey="label"
                  valueKey="id"
                  submit={submit}
                  option={payment}
                  name="payment"
                  setFormData={setFormData}
                />

                {formData.payment === "ConsultantFee" && (
                  <CustomInputs
                    // {...formData}
                    onChange={handleChange}
                    type="normal"
                    label="Amount"
                    submit={submit}
                    name="amount"
                    value={selected?.extendedProps?.details?.consultantFee}
                    disabled={true}
                    setFormData={setFormData}
                  />
                )}
                {formData.payment === "OtherPayment" && (
                  <CustomInputs
                    {...formData}
                    onChange={handleChange}
                    type="normal"
                    label="Amount"
                    submit={submit}
                    name="amount"
                    setFormData={setFormData}
                  />
                )}
                <CustomInputs
                  {...formData}
                  onChange={handleChange}
                  type="select"
                  label="Payment mode"
                  validation="required"
                  labelKey="label"
                  valueKey="id"
                  submit={submit}
                  option={paymentMode}
                  name="paymentMode"
                  setFormData={setFormData}
                />
                {formData.paymentMode === "Online" && (
                  <CustomInputs
                    {...formData}
                    onChange={handleChange}
                    type="normal"
                    label="Transaction Number"
                    submit={submit}
                    name="transactionNumber"
                    setFormData={setFormData}
                  />
                )}
              </div>
            )}
            {showCancel.type === "cancel" && (
              <div>
                <CustomInputs
                  {...formData}
                  onChange={handleChange}
                  type="normal"
                  label="Reason"
                  validation="required"
                  submit={submit}
                  name="reason"
                  setFormData={setFormData}
                />
              </div>
            )}
            <div className="mt-3 d-flex gap-3 justify-content-end">
              <button
                className="btn border text-secondary"
                onClick={() => setShowCancel({ show: false, id: "", type: "" })}
              >
                Cancel
              </button>
              <button
                className="btn btn-violet"
                onClick={() => handleCancelSubmit()}
              >
                Update
              </button>
            </div>
          </>
        }
        onClose={() => setShowCancel({ show: false, id: "", type: "" })}
      />
    </>
  );
};

export default AppointmentCalendarView;
